module.exports = __webpack_public_path__ + "img/dumpling_dip.dd2fcfe9.jpg";